import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material'
import { FC, KeyboardEvent, MouseEvent, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UtilityDetailActions, UtilityDetailSelector } from '../../store/utilityDetails'
import { WaterSystemsSelector, WaterSystemType } from '../../store/waterSystems'
import { useStyles } from '../../theme'
import { Loader, PublicUtilityDetail, WellUtilityDetail } from './subComponents'
import { MapRefProps } from '../../views'

interface UtilitySlideoutProps {
  setPopupPosition?: (position: { x: number; y: number } | null) => void
  setPopupDetails?: (details: any) => void
  setFillColor?: (color: string) => void
  mapRef?: React.MutableRefObject<MapRefProps | null>

}

export const UtilitySlideout: FC<UtilitySlideoutProps> = ({ mapRef }) => {
  const dispatch = useDispatch()
  const styles = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const selectedUtility = useSelector(WaterSystemsSelector.getSelectedWaterSystem)

  const waterSystemType = useSelector(WaterSystemsSelector.getSelectedWaterSystemType)
  const loading = useSelector(UtilityDetailSelector.getLoading)

  const showDrawer = useSelector(UtilityDetailSelector.getShowDrawer)

  useEffect(() => {

    if (selectedUtility) {
      dispatch(UtilityDetailActions.fetchUtilityDetailsAsync(selectedUtility) as any)
    }
  }, [selectedUtility, dispatch])


  const onClose = (e: MouseEvent | KeyboardEvent) => {
    dispatch(UtilityDetailActions.closeDrawer())
  }
  const container =  mapRef && mapRef.current && mapRef.current.mapContainer

  return (
    <Drawer
      anchor={isMobile ? 'bottom' : 'right'}
      open={showDrawer}
      ModalProps={{
        container:container
      }}
      onClose={onClose}
      variant='persistent'
      transitionDuration={{enter:500, exit: 1000}}
      slotProps={{
        paper: {
        sx: {
          '& .MuiDrawer-paper': {
            boxSizing: 'border-box',
          },

          width: '100%' ,
          height: isMobile ? '90%' : '100%',
          borderRadius: 0,
          //overflow: 'hidden',
          zIndex: theme.zIndex.drawer + 100,
          position: 'absolute',
          borderTopLeftRadius: isMobile ? '24px' : 0,
          borderTopRightRadius: isMobile ? '24px' : 0,

        },
      }}
      }
    >
      <Box
        height="100%"
        display="flex"
        flexDirection="column"
        sx={{
          ...styles.scrollbar,
        }}
      >

        {waterSystemType === WaterSystemType.WELL
          ? !loading && <WellUtilityDetail onClose={onClose} />
          : !loading && <PublicUtilityDetail onClose={onClose} />}
        {loading && <Loader size="large" />}
      </Box>
    </Drawer>
  )

}
